import { render, staticRenderFns } from "./outOfStock.vue?vue&type=template&id=16cb1200&scoped=true&"
import script from "./outOfStock.vue?vue&type=script&lang=js&"
export * from "./outOfStock.vue?vue&type=script&lang=js&"
import style0 from "./outOfStock.vue?vue&type=style&index=0&id=16cb1200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb1200",
  null
  
)

export default component.exports